import * as React from 'react';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CircularProgressWithLabel(props: CircularProgressProps & { value: number; time: number }) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress color="inherit" size={55} variant="determinate" value={Math.round((100 * props.value) / props.time)} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">{`${Math.round(props.value)}`}</Typography>
      </Box>
    </Box>
  );
}

export interface CustomCircularProgressProps {
  start: number;
  onTimerEnds: () => any;
}

export default function CustomCircularProgress(props: CustomCircularProgressProps) {
  const [time, setTime] = React.useState(props.start);

  React.useEffect(() => {
    const timer = setInterval(() => {
      if (time === 0) {
        clearInterval(timer);
        props.onTimerEnds();
      }
      setTime((prevTime) => {
        return prevTime - 1;
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [time]);

  return <CircularProgressWithLabel value={time} time={props.start} />;
}
